import { render, staticRenderFns } from "./ai-email-template-modal.vue?vue&type=template&id=139851b8&scoped=true"
import script from "./ai-email-template-modal.vue?vue&type=script&lang=ts"
export * from "./ai-email-template-modal.vue?vue&type=script&lang=ts"
import style0 from "./ai-email-template-modal.vue?vue&type=style&index=0&id=139851b8&prod&lang=scss"
import style1 from "./ai-email-template-modal.vue?vue&type=style&index=1&id=139851b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139851b8",
  null
  
)

export default component.exports